import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Proof } from '@feature/proof';
import { generateProofApi, generateProofOptions } from '@feature/proof/proofGenerator';
import { Id } from '@feature/utils';

const presentationProofApi = generateProofApi('/proof-file/presentation');
const { getProofsOptions, getProofsByOwnerOptions, createOrUpdateProofOptions, deleteProofOptions } =
  generateProofOptions('presentation', presentationProofApi);

export function getPresentationProofsByOwnerOptions(presentationId: Id, userId: Id): UseSuspenseQueryOptions<Proof[]> {
  return getProofsByOwnerOptions(presentationId, userId);
}

export function getPresentationProofsOptions(presentationId: Id): UseSuspenseQueryOptions<Proof[]> {
  return getProofsOptions(presentationId);
}

export function useUploadOrUpdatePresentationProof(presentationId: Id) {
  const queryClient = useQueryClient();
  return useMutation(createOrUpdateProofOptions(presentationId, queryClient));
}

export function useDeletePresentationProof(presentationId: Id) {
  const queryClient = useQueryClient();
  return useMutation(deleteProofOptions(presentationId, queryClient));
}
